<template>
  <footer class="page-footer">
    {{title}}
  </footer>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>
<style scoped>
footer {
  background-color: #5a5a5a;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-size: 14px;
}

</style>